export interface Filter<T> {
  resource: T;
  condition: unknown;
  value: unknown;
}

export enum FiltersOperator {
  all = 'all',
  any = 'any',
}
